import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPreviewListener = loadable(() => import(/* webpackChunkName: "content/guest/site/previewlistener" */ './PreviewListener'));
